export const DEFAULT_MAX_LABELS_TO_SHOW = 5;
